// Direction types enum for call directions
export enum CallDirectionTypes {
    INBOUND = 'Inbound',
    INBOUND_DIRECT = 'InboundDirect',
    OUTBOUND = 'Outbound',
    INTERNAL = 'Internal'
}